import { token } from '@atlaskit/tokens';
import messages from './messages.tsx';
import type { BackgroundColorMeta } from './types.tsx';

export const GREY_META: BackgroundColorMeta = {
	name: 'grey',
	messageLabel: messages.grey,
	color: token('color.background.neutral.bold'),
	textColor: token('color.text.inverse'),
};
const PURPLE_META: BackgroundColorMeta = {
	name: 'purple',
	messageLabel: messages.purple,
	color: token('color.background.discovery.bold'),
	textColor: token('color.text.inverse'),
};
const GREEN_META: BackgroundColorMeta = {
	name: 'green',
	messageLabel: messages.green,
	color: token('color.background.success.bold'),
	textColor: token('color.text.inverse'),
};
const YELLOW_META: BackgroundColorMeta = {
	name: 'yellow',
	messageLabel: messages.yellow,
	color: token('color.background.warning.bold'),
	textColor: token('color.text.warning.inverse'),
};
const RED_META: BackgroundColorMeta = {
	name: 'red',
	messageLabel: messages.red,
	color: token('color.background.danger.bold'),
	textColor: token('color.text.inverse'),
};

export const BACKGROUND_THEMES: BackgroundColorMeta[] = [
	GREY_META,
	PURPLE_META,
	GREEN_META,
	YELLOW_META,
	RED_META,
];
